import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportsLibrary = ({ reports, onGenerate, onSchedule, onExport }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'ready':
        return { icon: 'CheckCircle', color: 'var(--color-success)' };
      case 'generating':
        return { icon: 'Loader', color: 'var(--color-warning)' };
      case 'failed':
        return { icon: 'XCircle', color: 'var(--color-error)' };
      default:
        return { icon: 'Clock', color: 'var(--color-muted-foreground)' };
    }
  };

  const getValidationBadge = (validation) => {
    const badges = {
      complete: { label: 'Complete', color: 'bg-success/10 text-success' },
      pending: { label: 'Pending', color: 'bg-warning/10 text-warning' },
      failed: { label: 'Failed', color: 'bg-error/10 text-error' },
    };
    return badges?.[validation] || badges?.pending;
  };

  return (
    <div className="space-y-4">
      {reports?.map((report) => {
        const statusIcon = getStatusIcon(report?.status);
        const validationBadge = getValidationBadge(report?.validation);

        return (
          <div
            key={report?.id}
            className="p-4 border border-border rounded-lg hover:border-primary/50 transition-all"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-lg font-semibold text-foreground">{report?.name}</h3>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${validationBadge?.color}`}>
                    {validationBadge?.label}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">{report?.description}</p>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    <span>Last: {report?.lastGenerated}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    <span>{report?.frequency}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name={statusIcon?.icon} size={14} color={statusIcon?.color} />
                    <span className="capitalize">{report?.status}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 pt-3 border-t border-border">
              <button
                onClick={() => onGenerate?.(report)}
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium"
              >
                <Icon name="PlayCircle" size={16} />
                Generate Now
              </button>
              <button
                onClick={() => onSchedule?.(report)}
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
              >
                <Icon name="Calendar" size={16} />
                Schedule
              </button>
              <button
                onClick={() => onExport?.(report)}
                className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
              >
                <Icon name="Download" size={16} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReportsLibrary;